import apiSlice from "../api/apiSlice";

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTask: builder.query({
      query: (id) => `/tasks/${id}`,
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        //pessimistic update
        try {
          // Send the request and wait for the response
          const { data: updatedTask } = await queryFulfilled;

          // Update the cache with the new task
          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(updatedTask);
            })
          );
        } catch (error) {
          // If the request fails, handle the error
          console.error("Failed to add task:", error);
        }
      },
    }),

    editTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // passimistic update start
        try {
          const { data: updatedTask } = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              const draftTask = draft.find((t) => t.id == updatedTask.id);
              draftTask.taskName = updatedTask.taskName;
              draftTask.teamMember = updatedTask.teamMember;
              draftTask.project = updatedTask.project;
              draftTask.deadline = updatedTask.deadline;
              draftTask.status = updatedTask.status;
            })
          );
        } catch (error) {
          console.log(error);
        }
        // passimistic update end
      },
    }),

    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const patchUpdate = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            return draft.filter((task) => {
              return task.id !== arg;
            });
          })
        );
        try {
          const response = await queryFulfilled;
        } catch (error) {
          patchUpdate.undo();
        }
      },
    }),
  }),
});

export const {
  useAddTaskMutation,
  useEditTaskMutation,
  useGetTaskQuery,
  useGetTasksQuery,
  useDeleteTaskMutation,
} = tasksApi;
